(()=>{
"use strict";
const VERSION="GSF1.8-20260921";
const prior=window.__AKILTA_SCROLL_FOCUS__;
try{if(prior&&typeof prior.destroy==="function")prior.destroy()}catch(_){}
const html=document.documentElement;
const main=document.querySelector("#MainContent")||document.querySelector("main")||document.body;
if(!main)return;
const MQ=matchMedia("(max-width:900px)");
const RMQ=matchMedia("(prefers-reduced-motion: reduce)");
let owner=null,raf=0,destroyed=false,resizeTimer=0,arrivalTimer=0;
let sections=[],sectionMetrics=[],excludedMetrics=[],clusters=[],activeSection=null,activeFrame=null;
let horizontalHosts=[],resizeObserver=null,mutationObserver=null,lastWidth=0,lastHeight=0,geometryVersion=0;
let mutationTimer=0;
const clamp=(v,a,b)=>Math.max(a,Math.min(b,v));
const uniq=arr=>[...new Set(arr)];
const visible=el=>{
  if(!el||!el.isConnected||el.hidden)return false;
  if(el.matches?.("[data-ak-focus-disabled], [data-ak-focus-disabled] *"))return false;
  const cs=getComputedStyle(el);
  if(cs.display==="none"||cs.visibility==="hidden")return false;
  return el.getClientRects().length>0;
};
function resolveOwner(){
  const page=document.querySelector(".page-wrapper");
  if(!page)return window;
  const cs=getComputedStyle(page);
  return /(auto|scroll)/.test(cs.overflowY||"")&&page.scrollHeight>page.clientHeight+1?page:window;
}
function scrollTop(){return owner&&owner!==window?owner.scrollTop:(scrollY||document.documentElement.scrollTop||0)}
function viewportHeight(){return owner&&owner!==window?Math.max(1,owner.clientHeight):Math.max(1,innerHeight||document.documentElement.clientHeight)}
function measure(el){
  const r=el.getBoundingClientRect();
  if(owner&&owner!==window){
    const or=owner.getBoundingClientRect();
    const top=owner.scrollTop+(r.top-or.top);
    return{top,bottom:top+r.height,height:r.height};
  }
  const top=scrollTop()+r.top;
  return{top,bottom:top+r.height,height:r.height};
}
function bindOwner(){
  const next=resolveOwner();
  if(owner===next)return;
  if(owner)try{owner.removeEventListener("scroll",request)}catch(_){}
  owner=next||window;
  owner.addEventListener("scroll",request,{passive:true});
}
function directSurface(el){
  for(const child of el.children||[]){if(child.classList?.contains("ak-focus-surface"))return child}
  return null;
}
function ensureSurface(el,mode){
  if(!el||mode==="title"||mode==="quiet"||directSurface(el))return;
  const s=document.createElement("span");
  s.className="ak-focus-surface";
  s.setAttribute("aria-hidden","true");
  el.appendChild(s);
}
function titleFor(el){
  if(!el)return null;
  return el.querySelector("[data-ak-focus-title]")||el.querySelector("h2,h3")||el.querySelector(".cap-copy > b")||el.querySelector("strong,b");
}
function modeFor(el,host){
  const explicit=el?.dataset.akFocusMode||host?.dataset.akFocusMode;
  if(explicit&&["edge","surface","title","quiet"].includes(explicit))return explicit;
  const role=(el?.dataset.akBlockRole||"").toLowerCase();
  const signature=((host?.className||"")+" "+(el?.className||"")).toLowerCase();
  if(/system-page|legal|policy|utility/.test(signature))return"quiet";
  if(/proof|registry|evidence|editorial/.test(role+" "+signature))return"title";
  if(/product|offer|package|commercial|system|context/.test(role+" "+signature))return"surface";
  if(/capability|navigation/.test(role))return"edge";
  if(/steps|routes|route|fit|deliverable|faq|capabilit|principle|facts|points|line/.test(signature))return"edge";
  if(el?.tagName==="DETAILS"||el?.tagName==="ARTICLE")return"title";
  return"edge";
}
function mark(el,host){
  if(!el||!visible(el))return null;
  const mode=modeFor(el,host);
  if(!el.hasAttribute("data-ak-focus-frame")){
    el.setAttribute("data-ak-focus-frame","");
    el.setAttribute("data-ak-focus-runtime-frame","1");
  }
  if(!el.hasAttribute("data-ak-focus-mode")){
    el.setAttribute("data-ak-focus-mode",mode);
    el.setAttribute("data-ak-focus-runtime-mode","1");
  }
  ensureSurface(el,mode);
  const title=titleFor(el);
  if(title&&!title.hasAttribute("data-ak-focus-title")){
    title.setAttribute("data-ak-focus-title","");
    title.setAttribute("data-ak-focus-runtime-title","1");
  }
  return el;
}
function semanticChildren(host){
  if(!host)return[];
  const direct=[...host.children].filter(el=>!el.classList?.contains("ak-focus-surface")&&visible(el));
  const preferred=direct.filter(el=>el.matches?.("[data-ak-focus-item],[data-ak-system-block],article,a[href],li,details"));
  if(preferred.length>=2)return preferred;
  const marked=direct.filter(el=>el.hasAttribute?.("data-ak-system-block")||el.hasAttribute?.("data-ak-focus-item"));
  if(marked.length)return marked;
  const authored=direct.filter(el=>{
    const title=el.matches?.("h2,h3,h4,strong,b")?el:el.querySelector?.("h2,h3,h4,strong,b");
    return !!title&&String(el.textContent||"").trim().length>12;
  });
  if(authored.length>=2&&authored.length<=16)return authored;
  return[];
}
function sectionForHost(host){return host?.closest?.("[data-ak-chapter],[data-ak-focus-scope]")||main}
function cluster(host,items){
  if(!host||!visible(host))return null;
  const list=(items||semanticChildren(host)).map(el=>mark(el,host)).filter(Boolean);
  if(!list.length)return null;
  return{host,items:list,section:sectionForHost(host),metrics:null,itemMetrics:[],anchors:[],horizontal:false,horizontalMax:0};
}
function addCluster(out,used,host,items){
  if(!host||used.has(host))return;
  const c=cluster(host,items);
  if(c){out.push(c);used.add(host)}
}
function buildClusters(){
  const out=[],used=new Set();
  main.querySelectorAll("[data-ak-focus-group]").forEach(host=>{
    if(host.closest("[data-ak-focus-disabled],[data-ak-primary-hero]"))return;
    const direct=[...host.children].filter(el=>!el.classList?.contains("ak-focus-surface")&&visible(el));
    const explicit=direct.filter(el=>el.hasAttribute?.("data-ak-focus-item"));
    const items=explicit.length?explicit:direct;
    if(items.length>=1)addCluster(out,used,host,items);
  });
  main.querySelectorAll("[data-ak-focus-item]").forEach(item=>{
    if(item.closest("[data-ak-focus-group]")||item.closest("[data-ak-focus-disabled],[data-ak-primary-hero]"))return;
    addCluster(out,used,item,[item]);
  });
  main.querySelectorAll("[data-ak-composition]").forEach(host=>{
    if(host.closest("[data-ak-focus-disabled],[data-ak-primary-hero]"))return;
    addCluster(out,used,host);
  });
  const parents=uniq([...main.querySelectorAll("[data-ak-system-block]")].map(el=>el.parentElement).filter(Boolean));
  parents.forEach(host=>{
    if(host.closest("[data-ak-focus-disabled],[data-ak-primary-hero]"))return;
    const items=[...host.children].filter(el=>el.hasAttribute?.("data-ak-system-block"));
    if(items.length>=2)addCluster(out,used,host,items);
  });
  const inferredSelector=[
    '[class*="__cards"]','[class*="__grid"]','[class*="__list"]','[class*="__steps"]',
    '[class*="__routes"]','[class*="__fit"]','[class*="__principles"]','[class*="__capabilities"]',
    '[class*="__people"]','[class*="__records"]','[class*="__points"]','[class*="__facts"]',
    '[class*="__deliverables"]','[class*="__line"]'
  ].join(",");
  main.querySelectorAll(inferredSelector).forEach(host=>{
    if(host.closest("[data-ak-focus-disabled],[data-ak-primary-hero]"))return;
    const items=semanticChildren(host);
    if(items.length>=2&&items.length<=16)addCluster(out,used,host,items);
  });
  clusters=out;
}
function markSections(){
  const semantic=[...main.querySelectorAll("[data-ak-chapter]:not([data-ak-focus-disabled]):not([data-ak-primary-hero]),[data-ak-focus-scope]:not([data-ak-focus-disabled]):not([data-ak-primary-hero])")].filter(visible);
  sections=uniq(semantic);
  sections.forEach(section=>{
    section.setAttribute("data-ak-scroll-focus-scope","");
    const title=section.querySelector("h1,h2,h3");
    if(title)title.setAttribute("data-ak-section-focus-title","");
    const marker=section.querySelector(".ak-chapter-marker,.kicker,[class*='__eyebrow']");
    if(marker)marker.setAttribute("data-ak-section-focus-marker","");
  });
}
function unbindHorizontal(){horizontalHosts.forEach(host=>{try{host.removeEventListener("scroll",request)}catch(_){}});horizontalHosts=[]}
function bindHorizontal(){
  unbindHorizontal();
  horizontalHosts=clusters.filter(c=>c.horizontal).map(c=>c.host);
  horizontalHosts.forEach(host=>host.addEventListener("scroll",request,{passive:true}));
}
function focusAnchors(metrics){
  if(!metrics?.length)return[];
  const rows=[];
  for(const m of metrics){
    const center=(m.top+m.bottom)*.5;
    const last=rows[rows.length-1];
    const tolerance=last?clamp(Math.min(last.height,m.height)*.18,24,56):32;
    if(!last||Math.abs(m.top-last.top)>tolerance){
      rows.push({top:m.top,height:m.height,items:[{index:m.index,center}],center});
    }else{
      const count=last.items.length;
      last.items.push({index:m.index,center});
      last.top=(last.top*count+m.top)/(count+1);
      last.height=Math.max(last.height,m.height);
      last.center=(last.center*count+center)/(count+1);
    }
  }
  const anchors=Array(metrics.length);
  rows.forEach((row,rowIndex)=>{
    const count=row.items.length;
    if(count===1){anchors[row.items[0].index]=row.center;return}
    const prevGap=rowIndex>0?Math.max(1,row.center-rows[rowIndex-1].center):Infinity;
    const nextGap=rowIndex<rows.length-1?Math.max(1,rows[rowIndex+1].center-row.center):Infinity;
    const nearestGap=Math.min(prevGap,nextGap);
    const basis=Number.isFinite(nearestGap)?nearestGap:Math.max(120,row.height*.72);
    const span=clamp(basis*.28,32,120);
    row.items.forEach((item,itemIndex)=>{
      const t=count===1?0:itemIndex/(count-1);
      anchors[item.index]=row.center+(t-.5)*span;
    });
  });
  return anchors;
}
function measureGeometry(){
  sectionMetrics=sections.map(el=>({el,...measure(el)})).sort((a,b)=>a.top-b.top);
  excludedMetrics=[...main.querySelectorAll("[data-ak-primary-hero]")].filter(visible).map(el=>({el,...measure(el)}));
  clusters.forEach(c=>{
    c.metrics=measure(c.host);
    c.itemMetrics=c.items.map((el,index)=>({el,index,...measure(el)}));
    c.anchors=focusAnchors(c.itemMetrics);
    c.horizontalMax=Math.max(0,c.host.scrollWidth-c.host.clientWidth);
    c.horizontal=c.items.length>1&&c.horizontalMax>8;
  });
  const r=main.getBoundingClientRect();
  lastWidth=r.width;lastHeight=r.height;geometryVersion++;
  bindHorizontal();
}
function setSection(el){
  if(activeSection===el)return;
  if(activeSection)activeSection.classList.remove("is-ak-section-focus","is-ak-section-frame-focus");
  activeSection=el||null;
  if(activeSection)activeSection.classList.add("is-ak-section-focus");
  html.dataset.akFocusSection=activeSection?.id||activeSection?.classList?.[0]||"";
}
function setSectionPhase(hasFrame){if(activeSection)activeSection.classList.toggle("is-ak-section-frame-focus",!!hasFrame)}
function pulse(el){
  clearTimeout(arrivalTimer);
  main.querySelectorAll(".is-ak-arriving").forEach(n=>n.classList.remove("is-ak-arriving"));
  if(!el||RMQ.matches)return;
  el.classList.add("is-ak-arriving");
  arrivalTimer=setTimeout(()=>el.classList.remove("is-ak-arriving"),420);
}
function setFrame(el,c,index){
  if(activeFrame===el)return;
  if(activeFrame)activeFrame.classList.remove("is-ak-focus","is-ak-arriving");
  activeFrame=el||null;
  if(activeFrame){activeFrame.classList.add("is-ak-focus");if(!["title","quiet"].includes(activeFrame.dataset.akFocusMode))pulse(activeFrame)}
  const group=c?(c.host.dataset.akFocusGroup||c.host.dataset.akComposition||c.host.classList?.[0]||"group"):"";
  html.dataset.akFocusFrame=activeFrame&&c?(group+":"+index):"";
}
function isFocusExcludedAt(y){return excludedMetrics.some(m=>m.top<=y&&m.bottom>=y)}
function sectionForLine(y){
  if(isFocusExcludedAt(y))return null;
  let best=null,bestScore=Infinity;
  for(const m of sectionMetrics){
    if(m.top<=y&&m.bottom>=y)return m.el;
    const score=Math.min(Math.abs(m.top-y),Math.abs(m.bottom-y));
    if(score<bestScore){bestScore=score;best=m.el}
  }
  return best;
}
function activeClusterFor(section,focusY,viewTop,height){
  if(!section)return null;
  const bandTop=viewTop+height*(MQ.matches?.18:.20);
  const bandBottom=viewTop+height*(MQ.matches?.84:.82);
  let best=null,bestScore=Infinity;
  for(const c of clusters){
    if(c.section!==section||!c.metrics)continue;
    const r=c.metrics;
    if(r.bottom<bandTop||r.top>bandBottom)continue;
    const score=Math.abs((r.top+r.bottom)*.5-focusY);
    if(score<bestScore){bestScore=score;best=c}
  }
  return best;
}
function indexFor(c,viewTop,height,focusY){
  const n=c.items.length;
  if(n<=1)return 0;
  if(c.horizontal&&MQ.matches){
    const max=c.horizontalMax||0;
    if(max>1)return Math.min(n-1,Math.round(clamp(c.host.scrollLeft/max,0,1)*(n-1)));
  }
  const anchors=c.anchors||[];
  if(anchors.length!==n||anchors.some(v=>!Number.isFinite(v))){
    const r=c.metrics;if(!r)return 0;
    const start=viewTop+height*(MQ.matches?.82:.78);
    const end=viewTop+height*(MQ.matches?.22:.26);
    const travel=Math.max(1,r.height+(start-end));
    const p=clamp((start-r.top)/travel,0,.999999);
    return Math.min(n-1,Math.floor(p*n));
  }
  let best=0,bestDist=Infinity;
  anchors.forEach((anchor,index)=>{
    const dist=Math.abs(anchor-focusY);
    if(dist<bestDist){bestDist=dist;best=index}
  });
  const current=c.items.indexOf(activeFrame);
  if(current>=0&&current!==best){
    const currentDist=Math.abs(anchors[current]-focusY);
    const hysteresis=clamp(height*(MQ.matches?.022:.028),16,42);
    if(bestDist+hysteresis>=currentDist)return current;
  }
  return best;
}
function frame(){
  raf=0;if(destroyed)return;
  const viewTop=scrollTop(),height=viewportHeight(),focusY=viewTop+height*(MQ.matches?.50:.52);
  const inputFrame=main.contains(document.activeElement)?document.activeElement?.closest?.("[data-ak-focus-frame]"):null;
  const heroSuppressed=isFocusExcludedAt(focusY);
  if(inputFrame&&!inputFrame.closest("[data-ak-primary-hero]")){
    const inputSection=inputFrame.closest("[data-ak-chapter],.section[id]")||main;
    setSection(inputSection);setSectionPhase(true);
    if(activeFrame!==inputFrame){
      if(activeFrame)activeFrame.classList.remove("is-ak-focus","is-ak-arriving");
      activeFrame=inputFrame;
      activeFrame.classList.add("is-ak-focus");
    }
    html.dataset.akFocusFrame="keyboard";
  }else if(heroSuppressed){
    setSection(null);setSectionPhase(false);setFrame(null,null,-1);
  }else{
    const section=sectionForLine(focusY);
    setSection(section);
    const c=activeClusterFor(section,focusY,viewTop,height);
    setSectionPhase(!!c);
    if(c){const i=indexFor(c,viewTop,height,focusY);setFrame(c.items[i]||null,c,i)}else setFrame(null,null,-1);
  }
  window.__AKILTA_SCROLL_FOCUS_QA__={
    version:VERSION,owner:owner===window?"window":".page-wrapper",mobile:MQ.matches,
    section:html.dataset.akFocusSection||null,frame:html.dataset.akFocusFrame||null,
    sections:sections.length,clusters:clusters.length,geometryVersion,heroSuppressed,
    mode:"GLOBAL_SEMANTIC_HOME_REFERENCE_ATTENTION_RELAY_NO_HERO_FOCUS",scrollFrameLayoutReads:false
  };
}
function request(){if(!raf)raf=requestAnimationFrame(frame)}
function clearMarkers(){
  clearTimeout(arrivalTimer);
  main.querySelectorAll(".is-ak-focus,.is-ak-arriving,.is-ak-input-focus").forEach(el=>el.classList.remove("is-ak-focus","is-ak-arriving","is-ak-input-focus"));
  main.querySelectorAll(".is-ak-section-focus,.is-ak-section-frame-focus,.is-ak-section-input-focus").forEach(el=>el.classList.remove("is-ak-section-focus","is-ak-section-frame-focus","is-ak-section-input-focus"));
  main.querySelectorAll("[data-ak-focus-runtime-title='1']").forEach(el=>{
    el.removeAttribute("data-ak-focus-title");
    el.removeAttribute("data-ak-focus-runtime-title");
  });
  main.querySelectorAll("[data-ak-focus-frame]").forEach(el=>{
    if(el.dataset.akFocusRuntimeMode==="1"){
      el.removeAttribute("data-ak-focus-mode");
      el.removeAttribute("data-ak-focus-runtime-mode");
    }
    if(el.dataset.akFocusRuntimeFrame==="1"){
      el.removeAttribute("data-ak-focus-frame");
      el.removeAttribute("data-ak-focus-runtime-frame");
    }
    const s=directSurface(el);if(s)s.remove();
  });
  main.querySelectorAll("[data-ak-section-focus-title]").forEach(el=>el.removeAttribute("data-ak-section-focus-title"));
  main.querySelectorAll("[data-ak-section-focus-marker]").forEach(el=>el.removeAttribute("data-ak-section-focus-marker"));
  main.querySelectorAll("[data-ak-scroll-focus-scope]").forEach(el=>el.removeAttribute("data-ak-scroll-focus-scope"));
}
function rebuild(){
  if(destroyed)return;
  bindOwner();clearMarkers();markSections();buildClusters();measureGeometry();
  activeFrame=null;activeSection=null;html.classList.add("ak-scroll-focus-ready");request();
}
function onResize(){
  clearTimeout(resizeTimer);
  resizeTimer=setTimeout(()=>{
    if(destroyed)return;
    const r=main.getBoundingClientRect();
    if(Math.abs(r.width-lastWidth)<1&&Math.abs(r.height-lastHeight)<1){measureGeometry();request()}else rebuild();
  },140);
}
function onVisibilityMutation(){
  clearTimeout(mutationTimer);
  mutationTimer=setTimeout(()=>{if(!destroyed)rebuild()},80);
}
function onFocusIn(e){
  const frameEl=e.target?.closest?.("[data-ak-focus-frame]");
  if(frameEl){frameEl.classList.add("is-ak-input-focus");frameEl.closest("[data-ak-chapter],.section[id]")?.classList.add("is-ak-section-input-focus")}
}
function onFocusOut(e){
  const frameEl=e.target?.closest?.("[data-ak-focus-frame]");
  if(frameEl&&!frameEl.contains(e.relatedTarget)){
    frameEl.classList.remove("is-ak-input-focus");
    frameEl.closest("[data-ak-chapter],.section[id]")?.classList.remove("is-ak-section-input-focus");
    request();
  }
}
addEventListener("resize",onResize,{passive:true});
addEventListener("orientationchange",onResize,{passive:true});
document.addEventListener("focusin",onFocusIn,true);
document.addEventListener("focusout",onFocusOut,true);
document.addEventListener("shopify:section:load",rebuild);
document.addEventListener("shopify:section:unload",rebuild);
if(MQ.addEventListener)MQ.addEventListener("change",rebuild);
if(window.ResizeObserver){resizeObserver=new ResizeObserver(()=>onResize());resizeObserver.observe(main)}
if(window.MutationObserver){
  mutationObserver=new MutationObserver(onVisibilityMutation);
  mutationObserver.observe(main,{subtree:true,attributes:true,attributeFilter:["hidden","aria-hidden"]});
}
if(document.fonts?.ready)document.fonts.ready.then(rebuild).catch(rebuild);else rebuild();
function destroy(){
  destroyed=true;clearTimeout(resizeTimer);clearTimeout(arrivalTimer);clearTimeout(mutationTimer);
  if(raf)cancelAnimationFrame(raf);
  if(owner)try{owner.removeEventListener("scroll",request)}catch(_){}
  unbindHorizontal();resizeObserver?.disconnect();resizeObserver=null;mutationObserver?.disconnect();mutationObserver=null;
  removeEventListener("resize",onResize);removeEventListener("orientationchange",onResize);
  document.removeEventListener("focusin",onFocusIn,true);document.removeEventListener("focusout",onFocusOut,true);
  document.removeEventListener("shopify:section:load",rebuild);document.removeEventListener("shopify:section:unload",rebuild);
  try{MQ.removeEventListener?.("change",rebuild)}catch(_){}
  clearMarkers();html.classList.remove("ak-scroll-focus-ready");
}
window.__AKILTA_SCROLL_FOCUS__={version:VERSION,destroy,rebuild,request};
rebuild();
})();